<bringoz-button type="tertiary"
                [ngbTooltip]="tooltip"
                container="body"
                openDelay="300"
                triggers="hover"
                (onClick)="downloadFile()">
  <bringoz-icon iconName="download" class="primary-102"></bringoz-icon>

</bringoz-button>

<ng-template #tooltip>
  <span>{{description || 'Download' | translate}}</span>
</ng-template>
